import { render, staticRenderFns } from "./AddSupervisorModal.vue?vue&type=template&id=d29cbce6&"
import script from "./AddSupervisorModal.vue?vue&type=script&lang=js&"
export * from "./AddSupervisorModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports